// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__210R2","col":"styles_col__r8OR2"};